import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useSelectedProfileStore = create(
  persist(
    (set) => ({
      selectedBrandUid: null,
      selectedRegionUid: null,

      setSelectedProfile: ({ brandUid, regionUid }) =>
        set({ selectedBrandUid: brandUid, selectedRegionUid: regionUid }),
      setSelectedBrand: (brandUid) => set({ selectedBrandUid: brandUid }),
      setSelectedRegion: (regionUid) => set({ selectedRegionUid: regionUid }),
      clearSelectedProfile: () => set({ selectedBrandUid: null, selectedRegionUid: null }),
      clearSelectedBrand: () => set({ selectedBrandUid: null }),
      clearSelectedRegion: () => set({ selectedRegionUid: null }),
    }),
    {
      name: 'rambla-selected-profile',
      partialize: ({ selectedBrandUid, selectedRegionUid }) => ({
        selectedBrandUid,
        selectedRegionUid,
      }),
    },
  ),
);
